export default __webpack_public_path__ + "/dist/images/4588423.6c740bbc2374d6ba54c2b41e9f032733.png";